/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';

export const MostRecentEvictionSchema = z.enum(["NOT_PROVIDED", "NOT_REQUIRED", "NEVER", "LESS_THAN_3_YEARS_AGO", "BETWEEN_3_AND_7_YEARS_AGO", "MORE_THAN_7_YEARS_AGO"])
